// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emptySlot-3a97b {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #555555;\n  font-size: 2.8985507246377vw;\n  font-weight: 400;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"PingFang SC\", miui, Roboto, \"Helvetica Neue\", Helvetica, sans-serif;\n}\n", ""]);
// Exports
exports.locals = {
	"emptySlot": "emptySlot-3a97b"
};
module.exports = exports;
